import styled from "styled-components";

const ImageWrapper = styled.div<{ isZh: boolean }>`
  width: "100%";
  height: 80px;
  margin-bottom: 16px;
  img {
    width: 1342px;
    height: 80px;
  }
`;

const TopAdvertiseModule: React.FC<{
  activeName: string;
  isZh: boolean;
  imageUrlLink?: string;
  imageUrlLinkEventDetails?: string;
}> = ({
  isZh = true,
  imageUrlLink = "",
  imageUrlLinkEventDetails = "",
  activeName = "",
}) => {
  return (
    <>
      {imageUrlLink && (
        <ImageWrapper
          isZh={isZh}
          data-hs_click="operation_click"
          data-exposure
          data-exposure-event="operation_display"
          data-track={encodeURIComponent(
            JSON.stringify({
              operation_name: "网页端充值页banner",
              operation_rank: 1,
              content: activeName,
            })
          )}
        >
          {imageUrlLinkEventDetails ? (
            <a href={imageUrlLinkEventDetails} target="_blank" rel="noreferrer">
              <img src={imageUrlLink} alt="banner" />
            </a>
          ) : (
            <img src={imageUrlLink} alt="banner" />
          )}
        </ImageWrapper>
      )}
    </>
  );
};
export default TopAdvertiseModule;
